// src/components/strumenti/CalcolatoreSubnet.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

function ipToInt(ip) {
  const parti = ip.split(".").map(n => parseInt(n));
  if (parti.length !== 4 || parti.some(n => isNaN(n) || n<0 || n>255)) return null;
  return ((parti[0]<<24) | (parti[1]<<16) | (parti[2]<<8) | parti[3]) >>> 0;
}
function intToIp(n) {
  return [(n>>>24)&255, (n>>>16)&255, (n>>>8)&255, n&255].join(".");
}

export default function CalcolatoreSubnet() {
  const [ip, setIp] = useState("");
  const [cidr, setCidr] = useState("24");

  const ipInt = ip ? ipToInt(ip.trim()) : null;
  const prefisso = parseInt(cidr);
  const ipValido = ipInt !== null;
  const cidrValido = prefisso>=0 && prefisso<=32;

  let risultato = null;
  if (ipValido && cidrValido) {
    const mask = prefisso===0 ? 0 : (0xFFFFFFFF << (32-prefisso)) >>> 0;
    const network = (ipInt & mask) >>> 0;
    const broadcast = (network | (~mask >>> 0)) >>> 0;
    const numHostTotali = Math.pow(2, 32-prefisso);
    // W442: /31 = 2 indirizzi utilizzabili (punto-punto, RFC 3021); /32 = 1 (un solo host)
    const numHostUtilizzabili = prefisso===32 ? 1 : prefisso===31 ? 2 : numHostTotali-2;
    const primoHost = prefisso>=31 ? network : (network+1)>>>0;
    const ultimoHost = prefisso>=31 ? broadcast : (broadcast-1)>>>0;
    risultato = {
      network: intToIp(network),
      broadcast: intToIp(broadcast),
      mask: intToIp(mask),
      primoHost: intToIp(primoHost),
      ultimoHost: intToIp(ultimoHost),
      numHostUtilizzabili,
    };
  }

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Indirizzo IP</label>
          <input value={ip} onChange={e=>setIp(e.target.value)} style={{...inp, borderColor: ip&&!ipValido?"#fca5a5":"#e5e7eb"}} placeholder="Es. 192.168.1.10"/>
        </div>
        <div>
          <label style={lbl}>Prefisso (CIDR)</label>
          <div style={{ display:"flex", alignItems:"center", gap:4 }}>
            <span style={{ color:"#9ca3af" }}>/</span>
            <input value={cidr} onChange={e=>setCidr(e.target.value)} style={inp} placeholder="24"/>
          </div>
        </div>
      </div>
      {ip && !ipValido && <div style={{ fontSize:11, color:"#dc2626", marginTop:-10, marginBottom:14 }}>Indirizzo IP non valido</div>}

      {risultato && (
        <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"14px 16px" }}>
          <table style={{ width:"100%", fontSize:13 }}>
            <tbody>
              <tr><td style={{ color:"#6b7280", padding:"4px 0" }}>Subnet mask</td><td style={{ textAlign:"right", fontWeight:700, color:"#374151" }}>{risultato.mask}</td></tr>
              <tr><td style={{ color:"#6b7280", padding:"4px 0" }}>Indirizzo di rete</td><td style={{ textAlign:"right", fontWeight:700, color:"#374151" }}>{risultato.network}</td></tr>
              <tr><td style={{ color:"#6b7280", padding:"4px 0" }}>Indirizzo di broadcast</td><td style={{ textAlign:"right", fontWeight:700, color:"#374151" }}>{risultato.broadcast}</td></tr>
              <tr><td style={{ color:"#6b7280", padding:"4px 0" }}>Range host utilizzabili</td><td style={{ textAlign:"right", fontWeight:700, color:"#2563eb" }}>{risultato.primoHost} – {risultato.ultimoHost}</td></tr>
              <tr><td style={{ color:"#6b7280", padding:"4px 0" }}>N° host utilizzabili</td><td style={{ textAlign:"right", fontWeight:800, color:"#2563eb", fontSize:16 }}>{risultato.numHostUtilizzabili.toLocaleString("it-IT")}</td></tr>
            </tbody>
          </table>
        </div>
      )}

      <button onClick={()=>{setIp("");setCidr("24");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
